import React from "react";
import LoaderFullScreen from "../../shared/ui/loader/loaderFullscreen/LoaderFullScreen";

const LoaderFullScreenApp = () => {
	return <LoaderFullScreen />;
};
export default LoaderFullScreenApp;
